<template>

<div class="row">
    <div v-for='(f,i) in files' :class="[ 'file-item', { 'col-xl-3 col-sm-4 col-6' : $parent.grid, 'col-12' : !$parent.grid }]">
        <div :class="[ 'file-box', { row : !$parent.grid } ]">
            <div :class="{ 'col-xl-2 col-lg-3 col-sm-3 col-4' : !$parent.grid }">
                 <div class="file-preview img-overlay-holder">

                    <a v-if='f.mime_type.includes("image") && !f.mime_type.includes("dwg")' :href="f.file" :data-lightbox="'ft-' + config.lightBoxId">
                        <div class="img-overlay">
                            <span class="icon icon-zoom-in"></span>
                        </div>
                        <img :src="f.file" width="100%">
                    </a>

                    <span v-if='!f.mime_type.includes("image") || f.mime_type.includes("dwg")' :class="[ 'img-icon', getClass(f.ext) ]"></span>
                    
                </div> 
            </div>

            <div :class="{ 'col-xl-10 col-lg-9 col-sm-9 col-8' : !$parent.grid }">
                <div class="file-info">
                    <h5 class="file-name mb-2">{{ f.title ? f.title : f.name }}</h5>
                    <div :class="[ 'file-params d-flex mb-2', { 'justify-content-center' : $parent.grid, 'justify-content-start justify-content-md-between align-items-center flex-wrap' : !$parent.grid }]">
                        <span class="btn btn-gray btn-sm btn-file-info mr-1" @click="showParams( f.id )">
                            <span class="icon icon-info3 popover-trigger"></span>
                        </span>

                        <div :id=" 'popup' + f.id" class="popup">
                            <div v-if='typeof f.info_text == "string" || config.info' class="file-uploader">
                                <span class="icon icon-user"></span>
                                {{ typeof f.info_text == "string" ? f.info_text : config.info }}
                            </div>
                            <div v-if='f.desc' class=''>
                                Описание: {{ f.desc }}
                            </div>
                            <div class='file-date'>
                                Добавен: {{ bgDate(f.created_at) }}
                            </div>
                            <div class='file-size'>
                                Размер: {{ f.size }}
                            </div>
                            <div class="arrow"></div>
                        </div>

                        <div v-if='typeof f.info_text == "string" || config.info' class="file-uploader file-list">
                            <span class="icon icon-user"></span>
                            {{ typeof f.info_text == "string" ? f.info_text : config.info }}
                        </div>
                        <div class="file-date file-list mr-3">
                            <span class="icon icon-calendar"></span>
                                {{ bgDate( f.created_at ) }}
                        </div>
                        <div class="file-size file-list">
                            {{ f.size }}
                        </div>
                        <div class="file-btns">
                            <!-- <a v-if='config.preview' :href="f.file" target="_blank" class="btn btn-outline-secondary mr-2 btn-preview">
                                Преглед
                            </a> -->
                            <a v-if='config.download' class="btn btn-secondary btn-sm" 
                               :href="f.file" target="_blank" download>
                                <span class="icon icon-download mr-1"></span>
                                <span class="hide-on-grid">Свали</span>
                            </a>
                            
                            <button v-if='config.edit' @click='editFile(f,i)' 
                                    class="btn btn-warning btn-sm">
                                <span class="icon icon-book-open"></span>
                                <span class="hide-on-grid">Редактирай</span>
                            </button>

                            <button v-if='config.remove' @click='removeFile(f,i)' 
                                    class="btn btn-danger btn-sm">
                                <span class="icon icon-trash-2"></span>
                                <span class="hide-on-grid">Изтрий</span>
                            </button>
                        </div>

                    </div>

                    <div v-if='f.desc' class='file-desc'>
                        <span class="file-list">
                            <span class="icon icon-text mr-1"></span>
                            Описание:
                        </span> 
                        {{ f.desc }}
                    </div>
                    
                </div>
            </div>
        </div>  
    </div>

    <file-edit-modal :mid='mdlId' :file='forEdit'></file-edit-modal>
</div>

</template>

<script>
    export default {

        mounted() {
            
        },

        created() {
           
            if(  typeof this.conf == 'object' ) {
                this.config = Object.assign( {}, this.config, this.conf );
            }

            if( typeof this.params == 'object' && typeof this.params.ftid != 'undefined' ) {
                this.mdlId += this.params.ftid;
            } else {
                this.mdlId = parseInt( Math.random() * 10000 );
            }

         
        },

        props : ['files','conf','params'],

        data() {
            return {
                
                isReady : false,
                mdlId   : 'forEdit-',
                forEdit : false,
                config  : {
                    lightBoxId  : 'default-lb',
                    info        : false,
                    preview     : true,
                    download    : true,
                    remove      : false,
                    edit        : false,
                    removeUrl   : 'URL'
                }

            }
        },

        methods : {

            removeFile( f, i ) {

                if( !confirm('Сигурни ли сте, че искате да премахнете този файл?') ) {
                    return;
                }

                var me = this;

                me.ajax.call( this.config.removeUrl, { f : f.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        $.notify('Файлът беше премахнат успешно','success');
                        
                        me.$emit('file-removed', i, me.params );
                    }

                });

            },

            editFile( f, i ) {
                // this.forEdit = f;

                this.$set(this,'forEdit', f);

                this.$nextTick( () => {
                    $("#" + this.mdlId).modal('show');
                })


            },
         
            showParams( id ) {
                var elementID = '#popup' + id;

                if ( $( elementID ).hasClass( "show" ) ) {

                    $( elementID ).removeClass( "show" );

                } else {

                    $(".popup").removeClass("show");
                    $( elementID ).addClass( "show" );

                }

            },

            getClass( ext ) {

                switch(ext) {
                    case 'pdf'  : return 'icon-pdf';
                    case 'dwg'  : return 'icon-dwg';
                    case 'docx' : return 'icon-doc';
                    case 'doc'  : return 'icon-doc';
                    case 'xls'  : return 'icon-xls';
                    case 'xlsx' : return 'icon-xls';
                    case 'csv'  : return 'icon-csv';
                    case 'txt'  : return 'icon-text';
                    default     : return 'icon-file';
                }

            }

        },

        components : {
            'file-edit-modal' : require('./FileEditModal').default
        }

    }
</script>
